import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://test.api.schenck.one',
  apiBaseUrl: 'https://test.api.schenck.one/rc/api/v1', // against deployed/cloud backend
  usBaseUrl: 'https://test.api.schenck.one/user', //  for user settings api
  umBaseUrl: 'https://test.api.schenck.one/um/v2/rights/RC',
  amBaseUrl: 'https://test.api.schenck.one/am/v1', // against deployed/cloud backend
  apiVersion: '1.0',
  // DON'T change the following line! it will be replaced by a build-step with correct values
  versionInfo: {
    tag: 'test',
    hash: 'e56e90779022a2dac5a516d4a3ca2d9914114f1b',
    buildtimestamp: '2025-12-21T20:10:15.6037948Z',
    buildVersion: '3.0.0+4277',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: '1e99e0fe-30c5-4745-9475-fae34f11fa59',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://test.reportcenter.schenck.one',
        postLogoutRedirectUri: 'https://test.reportcenter.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/58a9657b-ab0c-45f2-8ae8-da25f14074a7/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
